export enum PipelineDetailsPanelNames {
  ACTIVITY = 'activity',
  FILTER = 'filter',
}
